import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-users-layout',
  templateUrl: './users-layout.component.html',
  styleUrls: ['./users-layout.component.scss']
})
export class UsersLayoutComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
